export default "__VITE_ASSET__cc4cc306__"